// cra imports
import React, { useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from 'reportWebVitals.js';

import { Provider } from 'react-redux';
import { PersistGate } from 'reduxjs-toolkit-persist/integration/react';
import { store, persistedStore } from 'store.js';
import { Helmet } from 'react-helmet';
import { REACT_HELMET_PROPS } from 'config.js';
import LangProvider from 'lang/LangProvider';
import { BrowserRouter as Router } from 'react-router-dom';
import RouteIdentifier from 'routing/components/RouteIdentifier';
import { getLayoutlessRoutes } from 'routing/helper';
import defaultRoutes from 'routing/default-routes';
import routesAndMenuItems from 'routes.js';
import { Slide, ToastContainer } from 'react-toastify';
const Main = () => {
  const layoutlessRoutes = useMemo(() => getLayoutlessRoutes({ data: routesAndMenuItems }), []);
 const preventClickjacking = () => {
    if (window.top !== window.self) {
      try {
        window.top.location = window.location.href;
      } catch (error) {
        if (error instanceof DOMException && error.name === 'SecurityError') {
          document.body.innerHTML = '<h1>Embedding is not allowed.</h1>';
          document.body.style.textAlign = 'center';
          document.body.style.marginTop = '50px';
          console.warn('Embedding blocked due to cross-origin restrictions.');
        } else {
          console.error('Unexpected error:', error);
        }
      }
    }
  };
useEffect(() => {

  preventClickjacking();
}, []);
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
  console.warn=()=>{};
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistedStore}>
        <Helmet {...REACT_HELMET_PROPS} />
        <ToastContainer transition={Slide} newestOnTop />
        <Router basename={process.env.REACT_APP_BASENAME}>
          <LangProvider>
            <RouteIdentifier routes={[...layoutlessRoutes, ...defaultRoutes]}/>
          </LangProvider>
        </Router>
      </PersistGate>
    </Provider>
  

  );
};

ReactDOM.render(<Main />, document.getElementById('root'));

/*
 * If you want to start measuring performance in your app, pass a function
 * to log results (for example: reportWebVitals(console.log))
 * or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
 */
reportWebVitals();
